import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {Affirmation} from '../../../models/applicationFeature';
import {Router} from '@angular/router';

@Component({
  selector: 'app-parent-affirmations',
  templateUrl: './parent-affirmations.component.html',
  styleUrls: ['./parent-affirmations.component.scss']
})
export class ParentAffirmationsComponent implements OnInit {
  affirmations: Affirmation[];
  @Input() children: any;

  constructor(private commonService: CommonService,
              private router: Router,
              public toastMessagesService: ToastMessagesService) {
    this.affirmations = [];
  }

  async ngOnInit() {
    await this.initAffirmations();
  }

  async initAffirmations() {
    try {
      const affirmationRequest = await this.commonService.getList(`affirmations/active`);
      const affirmations = affirmationRequest.object as Affirmation[];

      for (const affirmation of affirmations) {
        if (affirmation.classRestrictions && affirmation.classRestrictions !== 'null') {
          const restrictions = JSON.parse(affirmation.classRestrictions);
          for (const child of this.children) {
            for (const restriction of restrictions) {
              if (child.classId === restriction.id) {
                const index = this.affirmations.findIndex(a => a.id === affirmation.id);
                if (index === -1) {
                  this.affirmations.push(affirmation);
                }
              }
            }
          }
        } else {
          this.affirmations.push(affirmation);
        }
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

    async navigateToMyAffirmations() {
        await this.router.navigate(['/home/my-affirmations']);
    }
}
